var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hashtag)?_c('a',{staticClass:"hashtag",attrs:{"href":_vm.hashtagUrl,"target":"_blank","rel":"noopener noreferrer"}},[_c('icon',{staticClass:"icon",attrs:{"name":"hash","width":"18"}}),_c('span',[_vm._v(_vm._s(_vm.hashtag))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }